import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import MemberDetailsReportCard from "../../components/report/MemberDetailsReportCard";

const MemberDetailsReport = ({ token, admin }) => {

    const history = useHistory();

    const location = useLocation();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!location.state || !admin || !admin.user_detail) {
            history.push('/admin/dashboard')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">

                    <MemberDetailsReportCard
                        token={token}
                        country={admin?.country}
                        stampSetting={admin?.stamp}
                        tokenSetting={admin?.token}
                        pointSetting={admin?.loyalty_point}
                        userId={location.state?.userId}
                        memberId={location.state?.memberId}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        admin: state.admin.admin,
        token: state.admin.token,
    };
};

export default connect(mapStateToProps, null)(MemberDetailsReport);
